import { CompleteLargeUploadParams, useCompleteLargeUpload } from '@air/upload-utils';
import { useCallback } from 'react';

import { metadataForPublicUploadSelector } from '~/store/publicUploadMetadata/selectors';
import { useAirStore } from '~/utils/ReduxUtils';
import { sendPublicMultiPartUploadComplete } from '~/utils/uploadApi/publicUploadApi/publicLargeUploadApi';

export const useCompleteLargePublicUpload = () => {
  const store = useAirStore();
  const { completeLargeUpload } = useCompleteLargeUpload();

  const completeLargePublicUpload = useCallback(
    (params: Pick<CompleteLargeUploadParams, 'onUploadFinished' | 'uploadId' | 'onError'>) => {
      return completeLargeUpload({
        ...params,
        sendUploadComplete: (upload, sortedParts) => {
          const uploadMetadata = metadataForPublicUploadSelector(store.getState(), upload.id);
          return sendPublicMultiPartUploadComplete({
            uploadedParts: sortedParts,
            uploadUrlInfo: upload.s3Info.uploadUrlInfo,
            shortBoardId: uploadMetadata.shortBoardId,
          });
        },
      });
    },
    [completeLargeUpload, store],
  );

  return {
    completeLargePublicUpload,
  };
};
